import { render, staticRenderFns } from "./DisplayErrors.vue?vue&type=template&id=1dc8afe6&scoped=true"
import script from "./DisplayErrors.vue?vue&type=script&lang=ts"
export * from "./DisplayErrors.vue?vue&type=script&lang=ts"
import style0 from "./DisplayErrors.vue?vue&type=style&index=0&id=1dc8afe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8afe6",
  null
  
)

export default component.exports